import React from 'react'

const Home = () => {
  return (
    <div className='generalStyle'>
      <h1> Home</h1>
      <p> Welcome Users</p>
      <p> Click the login page to input your details</p>
    </div>
  );
};

export default Home;